import { ScenarioSelector } from "./ScenarioSelector";
import { InputEditor } from "./InputEditor";
import type { InputState, RunState } from "../hooks/useEngine";
import type { EngineError } from "../contracts/types";

interface WorkbenchProps {
  scenarioId: string;
  inputText: string;
  inputState: InputState;
  inputErrors: EngineError[];
  runState: RunState;
  onSelectScenario: (id: string) => void;
  onEditInput: (text: string) => void;
  onRun: () => void;
  onCancel: () => void;
}

export function Workbench({
  scenarioId,
  inputText,
  inputState,
  inputErrors,
  runState,
  onSelectScenario,
  onEditInput,
  onRun,
  onCancel,
}: WorkbenchProps) {
  const isProcessing = runState === "processing";
  const canRun = inputState !== "invalid" && inputState !== "too-large" && !isProcessing;

  return (
    <section id="workbench" aria-labelledby="workbench-heading">
      <h2 className="section-heading" id="workbench-heading">
        Workbench
      </h2>
      <div className="workbench-grid">
        <div className="panel">
          <ScenarioSelector scenarioId={scenarioId} onChange={onSelectScenario} />
          <InputEditor value={inputText} state={inputState} errors={inputErrors} onChange={onEditInput} />
          <div className="action-row">
            <button type="button" className="button button-primary" onClick={onRun} disabled={!canRun}>
              {isProcessing ? "Procesando…" : "Ejecutar escenario"}
            </button>
            {isProcessing ? (
              <button type="button" className="button button-secondary" onClick={onCancel}>
                Cancelar
              </button>
            ) : null}
          </div>
        </div>
        <div className="panel" aria-live="polite">
          <p>
            La ejecución corre en un Web Worker, fuera del hilo principal. Ningún dato sale de tu
            navegador: el motor es 100% determinista y local.
          </p>
          <p className="field-hint">
            Límites aplicados: hasta 60 rutas, 200 operaciones y 1000 hallazgos por ejecución; presupuesto
            de tiempo de 5 s antes de abortar.
          </p>
        </div>
      </div>
    </section>
  );
}
